import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7.556,17.556h8.889a2.207,2.207,0,0,0,2.222-2.191V8.635a2.207,2.207,0,0,0-2.222-2.191H7.556A2.207,2.207,0,0,0,5.334,8.635v6.729a2.206,2.206,0,0,0,2.222,2.192Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M16.444,6.286l-.68-2.621A2.22,2.22,0,0,0,13.614,2H10.386A2.222,2.222,0,0,0,8.235,3.665l-.68,2.621"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7.556,17.714l.68,2.621A2.22,2.22,0,0,0,10.386,22h3.228a2.221,2.221,0,0,0,2.151-1.665l.68-2.621"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M13.1,9.778a1.609,1.609,0,0,1,1.571,1.6c0,1.565-2.619,2.846-2.667,2.846s-2.667-1.281-2.667-2.846a1.609,1.609,0,0,1,1.571-1.6,1.443,1.443,0,0,1,1.1.475,1.451,1.451,0,0,1,1.1-.475Z"
		})
	]
});
export default SvgWatch;
